import { api } from "@/utils/api";
import { Module, Organization, Role } from "./Users";
import { sanitizePathParam } from "@/utils/sanitize";

export default class UserRepository {
  async getAllUsers(
    organizationId: any,
    page: number,
    size: number,
    username: string | null,
    roleId: string | number | null
  ) {
    const userRole = JSON.parse(localStorage.getItem("security") || "{}").role;
    const url =
      userRole == "SuperAdmin"
        ? `users/organizations/all`
        : `users/organizations/${organizationId}`;

    const res = await api.get(`${url}`, {
      params: {
        page,
        size,
        username,
        roleId,
      },
    });
    return res.data;
  }

  async createUser(data: any): Promise<boolean> {
    let result;
    if (data.userId) {
      const uid = sanitizePathParam(data.userId);
      result = await api.post(`users/${uid}`, data);
    } else {
      result = await api.post(`users/`, data);
    }

    return result.data;
  }

  async deleteUser(userId: any): Promise<boolean> {
    const uid = sanitizePathParam(userId);
    const result = await api.delete(`users/${uid}`);
    return result.data;
  }

  async getRole() {
    const res = await api.get(`security/roles`);
    return res.data.map((rol: Role) => {
      return {
        value: rol.id,
        label: rol.name,
      };
    });
  }

  async getModules() {
    const res = await api.get(`security/modules`);
    return res.data.map((module: Module) => {
      return {
        value: module.id,
        label: module.name,
      };
    });
  }

  async getOrganizations() {
    const res = await api.get(`security/organizations`);
    return res.data.map((organization: Organization) => {
      return {
        value: organization.id,
        label: organization.name,
      };
    });
  }

  async getLocationsIdsByUser(userId: any) {
    const uid = sanitizePathParam(userId);
    const result = await api.get(`users/${uid}/locations/ids`);
    return result.data;
  }

  async postLocationsUser(userId: any, data: any) {
    const uid = sanitizePathParam(userId);
    const result = await api.post(`users/${uid}/locations`, data);
    return result.data;
  }

  async getUsersSettings(id: number | string) {
    const sid = sanitizePathParam(id);
    const res = await api.get(`users/${sid}/settings`);
    return res.data.reduce((acc, item) => {
      const settingsObj = Array.isArray(item.settings)
        ? item.settings.reduce((o, { key, value }) => {
            o[key] = value;
            return o;
          }, {})
        : {};

      acc[item.groupKey] = { settings: settingsObj };
      return acc;
    }, {});
  }

  async getUserSettingByOrganizationId(organizationId: number | string) {
    const oid = sanitizePathParam(organizationId);
    const res = await api.get(`users/${oid}/settings`);
    return res.data;
  };

  async getUserInfo(userId: string) {
    const uid = sanitizePathParam(userId);
    const res = await api.get(`users/${uid}`);
    return res.data;
  }

  async acceptEula(userId: string, eulaVersion?: number) {
    const uid = sanitizePathParam(userId);
    const res = await api.post(`users/${uid}/accept-eula`, {
      eulaVersion,
    });
    return res.data;
  }

}
